import React from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'
import { intl } from 'src/i18n'
export const Footer = () => {
  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <p className={styles.subtitle}>{intl.t('newsletter.footer.form')}</p>
        <iframe
          className={styles.iframe}
          src={`https://cdn.forms-content.sg-form.com/98388cb6-dd00-11ed-bba7-b2a480f00fab`}
        />
      </div>
      <div className={styles.image}>
        <Image
          src={`/assets/images/newsletter/robot.svg`}
          width='319'
          height='319'
          alt='robot'
        />
      </div>
    </div>
  )
}
